<div class="image-container">
  <img src="../../assets/AG_Zest.png" class="image-item" />
</div>
<div class="card">
  <h2 class="card-header">Enter new password</h2>

  <div class="card-body">
    <form [formGroup]="forgotForm" (ngSubmit)="newPassword()" autocomplete="off">
      <div class="identifier-container">
        <label>Identifier (E-mail):</label>
        <input type="text" class="form-control" formControlName="identifier" [ngClass]="{ 'is-invalid': submitted && f.identifier.errors }" readonly />

        <div *ngIf="submitted && f.identifier.errors" class="invalid-feedback">
          <div *ngIf="f.identifier.errors.required">Identifier required</div>
          <div *ngIf="f.identifier.errors.email">Identifier must be a valid email address</div>
        </div>
      </div>
      <div class="top-container">
        <div class="form-group">
          <label>New Password:</label>
          <input type="password" formControlName="password" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.password.errors }" placeholder="Required field" />

          <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
            <div *ngIf="f.password.errors.required">Password is required and min. length is 6 characters</div>
            <div *ngIf="f.password.errors.minlength">Min. length is 6 characters</div>
          </div>
        </div>
        <div class="form-group">
          <label>Confirm New Password:</label>
          <input type="password" formControlName="confirmPassword" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.confirmPassword.errors }" placeholder="Required field" />

          <div *ngIf="submitted && f.confirmPassword.errors" class="invalid-feedback">
            <div *ngIf="f.confirmPassword.errors.required">Confirm Password is required and min. length is 6 characters</div>
          </div>
        </div>
      </div>
      <div class="form-group">
        <button [class.black]="isWaitingResponse | async" [disabled]="isWaitingResponse | async" class="save-changes">Enter</button>
      </div>
      <div *ngIf="userCreationFail" class="error">New password request failed.</div>
    </form>
  </div>
</div>
